module.exports = __webpack_public_path__ + "static/get_started-ea2e26d28621b86419682c2c7470ae9e.jpg";